/*@ngInject*/
const LoadingBarHandler = function ($rootScope, $timeout, coreConstant) {

    this.isLoading = false;
    this.isNotificationLoading = false;

    this.showLoadingBar = function (messageKey) {
        $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR, messageKey);
        this.isLoading = true;
    };

    this.showNotificationLoadingBar = function (message) {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION_LOADING_BAR, message);
        this.isNotificationLoading = true;
    };

    this.showFadingNotificationLoadingBar = function (message) {
        this.showNotificationLoadingBar(message);
        $timeout(function () {
            this.hideNotificationLoadingBar(true);
        }.bind(this), 1000);
    };

    this.concludeNotificationLoadingBar = function (message) {
        $rootScope.$broadcast(coreConstant.event.CONCLUDE_FADING_NOTIFICATION_LOADING_BAR, message);
        this.isNotificationLoading = false;
    };

    this.hideLoadingBar = function () {
        $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
        this.isLoading = false;
    };

    this.hideNotificationLoadingBar = function (isHard) {
        $rootScope.$broadcast(coreConstant.event.HIDE_FADING_NOTIFICATION_LOADING_BAR, isHard);
        this.isNotificationLoading = false;
    };

    this.isLoadingBarVisible = function () {
        return this.isLoading;
    };

    this.isNotificationLoadingBarVisible = function () {
        return this.isNotificationLoading;
    };
};

angular.module('umCore')
    .service('loadingBarHandler', LoadingBarHandler);
